import * as React from 'react';
import { useSelector } from 'react-redux';

import { getJsonQuery } from '../../selectors/getJsonQuery';
import { getUser } from '../../selectors/user';
import { NewbuildingSpecialProject } from '../../serp/components/adfox/templates/NewbuildingSpecialProject';
import { sendAdsEvent } from '../../tracking/sendAdsEvent';
import { INewbuildingSpecialProjectBannerContext } from '../../types/adfox';
import { trackSpecialProjectAdFoxBanner } from './tracking';

export interface ISpecialProjectAdfoxBannerContainerProps {
  context: INewbuildingSpecialProjectBannerContext;
}

export function SpecialProjectAdfoxBannerContainer({ context }: ISpecialProjectAdfoxBannerContainerProps) {
  const user = useSelector(getUser);
  const jsonQuery = useSelector(getJsonQuery);

  const onTrack = React.useCallback(
    (isShow: boolean) => {
      const { bannerId, campaignId, builderId } = context;

      if (bannerId && campaignId && builderId) {
        sendAdsEvent({
          realtyUserId: user.isAuthenticated ? user.userId : undefined,
          action: isShow ? 'show' : 'click',
          bannerId,
          bannerPlace: 'offersSerp',
        });

        trackSpecialProjectAdFoxBanner({
          action: isShow ? 'show_sopr' : 'click',
          bannerId,
          campaignId,
          builderId,
          jsonQuery,
        });
      }

      return;
    },
    [context, user, jsonQuery, trackSpecialProjectAdFoxBanner, sendAdsEvent],
  );

  return <NewbuildingSpecialProject context={context} onTrack={onTrack} />;
}
